// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__oAgAx","list":"BalanceDue_list__2504J","listRow":"BalanceDue_listRow__33TBQ","total":"BalanceDue_total__1dCuO"};